import { BetaFeaturesServiceProvider } from "./../feature-toggles/providers/beta-features.provider";
import { SharedModule } from "./../shared/shared.module";
import { SubNavigationComponent } from "./components/navigation/sub-navigation/sub-navigation.component";
import { NavigationV2Component } from "./components/navigation/navigation.component";
import { NgModule } from "@angular/core";
import { Ng1StateProxyProvider } from "@webapp/core/provider-upgrade/providers/ng1-state.proxy";
import { HomeServiceProvider } from "@webapp/home/providers/home.provider";
import { InsightboardsServiceProvider } from "@webapp/insightboards/providers/insightboards.provider";
import { MetricServiceProvider } from "@webapp/okrs/metrics/providers/metrics.provider";
import { AuthenticationResolverServiceProvider } from "@webapp/authentication/providers/authentication-resolver.provider";
import { UserProfileServiceProvider } from "@webapp/users/providers/user-profile.provider";
import { SessionsServiceProvider } from "@webapp/sessions/providers/sessions.provider";
import { TasksServiceProvider } from "@webapp/tasks/providers/tasks.provider";
import { WhiteboardsServiceProvider } from "@webapp/whiteboards/providers/whiteboards.provider";
import { KpisServiceProvider } from "@webapp/kpis/providers/kpis.provider";
import { ReportsServiceProvider } from "@webapp/reports/providers/reports.provider";
import { CurrentUserServiceProvider, EmployeeServiceProvider } from "@webapp/people/providers/people.provider";
import { GoalsServiceProvider } from "@webapp/sessions/providers/goals.provider";
import { UiModule } from "@webapp/ui/ui.module";
import { CommonModule } from "@angular/common";
import { DefaultSubNavigationComponent } from "./components/navigation/sub-navigation/default-sub-navigation/default-sub-navigation.component";
import { HomeSubNavigationComponent } from "./components/navigation/sub-navigation/home-sub-navigation/home-sub-navigation.component";
import { InsightboardsSubNavigationComponent } from "./components/navigation/sub-navigation/insightboards-sub-navigation/insightboards-sub-navigation.component";
import { KpisSubNavigationComponent } from "./components/navigation/sub-navigation/kpis-sub-navigation/kpis-sub-navigation.component";
import { NavItemsListComponent } from "./components/navigation/sub-navigation/nav-items-list/nav-items-list.component";
import { NavListItemComponent } from "./components/navigation/sub-navigation/nav-items-list/nav-list-item/nav-list-item.component";
import { PeopleSubNavigationComponent } from "./components/navigation/sub-navigation/people-sub-navigation/people-sub-navigation.component";
import { ReportsSubNavigationComponent } from "./components/navigation/sub-navigation/reports-sub-navigation/reports-sub-navigation.component";
import { SessionsSubNavigationComponent } from "./components/navigation/sub-navigation/sessions-sub-navigation/sessions-sub-navigation.component";
import { SettingsSubNavigationComponent } from "./components/navigation/sub-navigation/settings-sub-navigation/settings-sub-navigation.component";
import { TitledSubNavOptionsComponent } from "./components/navigation/sub-navigation/settings-sub-navigation/titled-sub-nav-options/titled-sub-nav-options.component";
import { SubNavOptionsComponent } from "./components/navigation/sub-navigation/sub-nav-options/sub-nav-options.component";
import { TasksSubNavigationComponent } from "./components/navigation/sub-navigation/tasks-sub-navigation/tasks-sub-navigation.component";
import { WhiteboardsSubNavigationComponent } from "./components/navigation/sub-navigation/whiteboards-sub-navigation/whiteboards-sub-navigation.component";
import { ActiveNavScreenService } from "./services/active-nav-screen.service";
import { ExpandNavV2ServiceProvider } from "./navigation.provider";
import { ToggleNavComponent } from "./components/toggle-navigation/toggle-nav.component";
import { NavListItemContextMenuComponent } from "./components/navigation/sub-navigation/nav-items-list/nav-list-item/nav-list-item-context-menu/nav-list-item-context-menu.component";
import { AccountServiceProvider } from "@webapp/accounts/providers/account.provider";
import { ProgressColoringProvider } from "@webapp/configuration/providers/progress-coloring.provider";
import { NavListItemIconComponent } from "./components/navigation/sub-navigation/nav-items-list/nav-list-item/nav-list-item-icon/nav-list-item-icon.component";
import { FeatureToggleServiceProvider } from "@webapp/feature-toggles/providers/feature-toggle-service.provider";
import { ViewHistoryFactoryProvider, ViewHistoryServiceProvider } from "@webapp/view-history/providers/view-history.provider";
import { FavoritesFactoryProvider } from "@webapp/favorites/favorites.provider";
import { AnalyticsServiceProvider } from "@webapp/core/provider-upgrade/providers/analytics-service.provider";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { UIErrorHandlingServiceProvider } from "@webapp/error-handling/providers/ui-error-handling-service.provider";
import { SuggestedModule } from "./services/uxcustomization/suggested/suggested.module";
import { SystemOptionsVisibilityService } from "./services/settings/system-options-visibility.service";
import { UserOptionsVisibilityService } from "./services/settings/user-options-visibility.service";
import { SettingsVisibilityService } from "./services/settings/settings-visibility.service";
import { IntegrationsOptionsVisibilityService } from "./services/settings/integrations-options-visibility.service";
import { AccountOptionsVisibilityService } from "./services/settings/account-options-visibility.service";
import { SettingsSubNavStateService } from "./services/settings/settings-sub-nav-state.service";
import { FavoritesModule } from "@webapp/favorites/favorites.module";
import { RecentsModule } from "./services/uxcustomization/recents/recents.module";
import { FavoritesPayloadBuilder } from "./utils/favorites-payload.builder";
import { ViewHistoryPayloadBuilder } from "./utils/view-history-payload.builder";
@NgModule({
  declarations: [
    NavigationV2Component,
    SubNavigationComponent,
    NavItemsListComponent,
    NavListItemComponent,
    NavListItemContextMenuComponent,
    HomeSubNavigationComponent,
    SessionsSubNavigationComponent,
    SubNavOptionsComponent,
    KpisSubNavigationComponent,
    TasksSubNavigationComponent,
    DefaultSubNavigationComponent,
    WhiteboardsSubNavigationComponent,
    SettingsSubNavigationComponent,
    InsightboardsSubNavigationComponent,
    TitledSubNavOptionsComponent,
    ReportsSubNavigationComponent,
    PeopleSubNavigationComponent,
    ToggleNavComponent,
    NavListItemIconComponent,
  ],
  imports: [SharedModule, UiModule, CommonModule, DragDropModule, SuggestedModule, FavoritesModule, RecentsModule],
  providers: [
    SettingsVisibilityService,
    SystemOptionsVisibilityService,
    UserOptionsVisibilityService,
    SettingsSubNavStateService,
    IntegrationsOptionsVisibilityService,
    AccountOptionsVisibilityService,
    ActiveNavScreenService,
    Ng1StateProxyProvider,
    HomeServiceProvider,
    AccountServiceProvider,
    ProgressColoringProvider,
    InsightboardsServiceProvider,
    MetricServiceProvider,
    AuthenticationResolverServiceProvider,
    BetaFeaturesServiceProvider,
    UserProfileServiceProvider,
    SessionsServiceProvider,
    TasksServiceProvider,
    WhiteboardsServiceProvider,
    ReportsServiceProvider,
    EmployeeServiceProvider,
    CurrentUserServiceProvider,
    KpisServiceProvider,
    GoalsServiceProvider,
    ExpandNavV2ServiceProvider,
    FeatureToggleServiceProvider,
    ViewHistoryServiceProvider,
    ViewHistoryFactoryProvider,
    FavoritesFactoryProvider,
    AnalyticsServiceProvider,
    UIErrorHandlingServiceProvider,
    FavoritesPayloadBuilder,
    ViewHistoryPayloadBuilder,
  ],
})
export class NavigationModule {}
